var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "message_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M555.8 907.5l20-22.1c-6.7 1-13.5 1.8-20.3 2.5l.3 19.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M512 3.2C267.7 3.2 69.6 201.3 69.6 445.6c0 237.1 186.5 430.6 420.8 441.9l1.9 98.8c0 .6-.1 1.3-.1 1.9 0 7.6 2.6 14.7 7 20.2 6 7.5 15.2 12.4 25.6 12.4h.5c10.3-.2 19.4-5.1 25.3-12.6L695 848.5c153-69.6 259.4-223.8 259.4-402.9C954.4 201.3 756.3 3.2 512 3.2zm266.9 709.3c-32.5 32.5-69.9 58.4-111.4 77.1-3.1.8-6.1 2.2-8.8 3.8-2.2 1.4-4.2 3-6 4.8-.5.5-1 1-1.4 1.5-.4.4-.7.8-1.1 1.3l-74.5 82.3-20 22.1-.4-19.6-.5-28.3c0-.6.1-1.3.1-1.9 0-7.4-2.5-14.3-6.7-19.7-.4-.5-.7-.9-1.1-1.3-.1-.1-.2-.2-.3-.4l-.9-.9-.3-.3-.9-.9-.3-.3c-.4-.4-.8-.8-1.2-1.1-.4-.4-.9-.7-1.3-1-.2-.1-.3-.2-.5-.3-.3-.2-.5-.4-.8-.6-.2-.1-.4-.3-.6-.4-.2-.1-.4-.2-.6-.4-.5-.3-.9-.6-1.4-.8-.1-.1-.3-.1-.4-.2-.3-.2-.6-.3-.9-.5-.2-.1-.5-.2-.7-.3-.3-.1-.6-.3-1-.4-6.8-2.9-12.5-2.8-12.5-2.8-3.5.1-7 .1-10.6.1-51 0-100.4-10-146.9-29.6-44.9-19-85.3-46.2-120-80.9s-61.9-75-80.9-120c-19.7-46.5-29.6-95.9-29.6-146.9s10-100.4 29.6-146.9c19-44.9 46.2-85.3 80.9-120s75-61.9 120-80.9c46.6-19.7 96-29.7 147-29.7s100.4 10 146.9 29.6c44.9 19 85.3 46.2 120 80.9s61.9 75 80.9 120c19.7 46.5 29.6 95.9 29.6 146.9s-10 100.4-29.6 146.9c-19 45-46.2 85.3-80.9 120z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M337.9 300.7h348.2M337.9 431h348.2M337.9 565.6h203.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default ForwardRef;